import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import { bindActionCreators } from 'redux';
import UserList from '../../classroom/students/AddUsers/UserList';
import { searchUserWithAttachments } from '../../../../src/services/domain/taskService';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class DisableEvaluationsReveal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    assignmentsDrawerActions: PropTypes.any,
    selectedTask: PropTypes.object,
    tasks: PropTypes.object
  };

  closeModal = () => {
    this.props.revealActions.openDisableEvaluationsReveal(false);
  };

  disableEvaluations = () => {
    this.props.assignmentsDrawerActions.setAllowFile(false);
    this.props.revealActions.openDisableEvaluationsReveal(false);
  };

  render() {
    const { tasks } = this.props;

    return (
      <Modal
        id="disable-files-activity"
        title={I18n.t('disableEvaluationsReveal.title')}
        active
        onClickOutside={this.closeModal}
        style={{ zIndex: '1400' }}
        children={
          <>
            <Paragraph className="text-grey-700">{I18n.t('disableEvaluationsReveal.body')}</Paragraph>
            <div className="margin-top-20">
              <UserList users={searchUserWithAttachments(tasks.selectedTask)} />
            </div>
          </>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button
              onClick={this.disableEvaluations}
              primary
              label={I18n.t('disableEvaluationsReveal.disable')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    tasks: state.task
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DisableEvaluationsReveal);
